import { Stack } from "@mantine/core"

import { CertificateVerificationDrawer } from "~/pages/Brand/Certificates/components/CertificateVerificationDrawer"
import { CertificatesList } from "~/pages/Brand/Certificates/components/CertificatesList"
import { CertificatesTableHeaders } from "~/pages/Brand/Certificates/components/CertificatesTableHeaders"
import { useCertificatesTableContext } from "~/pages/Brand/Certificates/provider/CertificatesTableContext"

export const CertificatesTable = () => {
  const { selectedCertificateInfo, setSelectedCertificateInfo } =
    useCertificatesTableContext()

  return (
    <Stack>
      <Stack justify="space-between">
        <CertificatesTableHeaders />
      </Stack>
      <CertificatesList />
      {selectedCertificateInfo && (
        <CertificateVerificationDrawer
          certificate={selectedCertificateInfo}
          onClose={() => setSelectedCertificateInfo(null)}
          opened={!!selectedCertificateInfo}
        />
      )}
    </Stack>
  )
}
